import $ from 'jquery';

$(document).ready(() => {
	$('.navbar .hamburger').bind('click', (event) => {
		if ($(event.currentTarget).hasClass('collapsed')) {
			$(event.currentTarget).addClass('is-active');
		} else {
			$(event.currentTarget).removeClass('is-active');
		}
	});
});



// WEBPACK FOOTER //
// ./src/js/components/nav.js